<template>
  <entity-list-table
    :title="title"
    :data-service="dataService"
    :headers="headers"
    :create-route-name="createRouteName"
    :edit-route-name="editRouteName"
    :allow-delete="allowDelete"
    :show-status-column="showStatusColumn"
    :filter="filter"
    class="menu-items-list"
  >
    <template v-slot:before-create-btn>
      <v-btn
        class="mr-2"
        depressed
        color="success"
        :loading="loadingExcel"
        large
        @click="downloadExcell"
      >
        Выгрузить в Excel
      </v-btn>
    </template>
    <template v-slot:filter>
      <div class="d-flex justify-lg-space-between align-center">
        <div class="menu-brands-filter">
          <source-horizontal-filter
            v-model="selectedSource"
          />
        </div>
        <div class="menu-items-list_active-filter">
          <v-switch
            v-model="showOnlyActive"
            label="Только активные"
          />
        </div>
      </div>
    </template>
    <template v-slot:item.hide="{ item }">
      <span
        v-if="item.hide"
        class="color-red"
      ><font-awesome-icon
        icon="eye-slash"
      /></span>
    </template>
    <template v-slot:item.hideInCrm="{ item }">
      <span
        v-if="item.hideInCrm"
        class="color-red"
      ><font-awesome-icon
        icon="eye-slash"
      /></span>
    </template>

    <template v-slot:item.menuItemSources="{ item }">
      <span v-if="item.menuItemSources" class="menu-items-list_sources">
        <v-chip
          v-for="sourceItem in item.menuItemSources"
          :key="`source-chip-${sourceItem.id}`"
          class="menu-items-list_sources-item"
          small
          :color="sourceItem.status ? 'success' : ''"
        >
          {{ sourceItem.source.name }}
        </v-chip>
      </span>
    </template>

    <template v-slot:item.soySauceCount="{ item }">
      <span v-if="item.soySauceCount" class="">{{ item.soySauceCount }}</span>
    </template>
    <template v-slot:item.imbirCount="{ item }">
      <span v-if="item.imbirCount" class="">{{ item.imbirCount }}</span>
    </template>
    <template v-slot:item.vasabiCount="{ item }">
      <span v-if="item.vasabiCount" class="">{{ item.vasabiCount }}</span>
    </template>

    <template v-slot:item.categories="{ item }">
      <menu-item-category :item="item" />
    </template>
  </entity-list-table>
</template>

<script>
  import MenuItemsDataService from '@/services/api/MenuItemsDataService'
  import EntityListTable from '@/components/ui/crud/EntityListTable'
  import BrandsHorizontalFilter from '@/components/filters/BrandsHorizontalFilter.vue'
  import AggregatorsBrand from '@/models/enums/AggregatorsBrand'
  import SourceHorizontalFilter from '@/components/filters/SourceHorizontalFilter.vue'
  import MenuItemCategory from '@/components/stat/menu/MenuItemCategory.vue'

  export default {
    components: { MenuItemCategory, SourceHorizontalFilter, EntityListTable },
    data () {
      return {
        title: 'Меню',
        dataService: MenuItemsDataService,
        createRouteName: 'menuItemCreate',
        editRouteName: 'menuItemEdit',
        loadingExcel: false,
        selectedSource: null,
        showOnlyActive: false,

        headers: [
          { text: 'ID', value: 'id', align: 'start' },
          { text: 'Название', value: 'name', align: 'start' },
          { text: 'Код в Юпитер', value: 'externalId', align: 'start' },
          {
            text: 'Категория',
            value: 'categoryString',
            align: 'left',
          },
          { text: 'Цена', value: 'price', align: 'end', type: 'price' },
          { text: 'Бонусы, %', value: 'bonusAdd', align: 'center' },
          // { text: 'Себестоимость', value: 'costPriceRub', align: 'start' },

          // { text: 'Соевый соус', value: 'soySauceCount', align: 'start' },
          // { text: 'Имбирь', value: 'imbirCount', align: 'start' },
          // { text: 'Васаби', value: 'vasabiCount', align: 'start' },

          // { text: 'Себестоимость с мод.', value: 'costPriceModRub', align: 'start' },
          // { text: 'Удвоение 2.0', value: 'isDoubling', align: 'center' },
          { text: 'Индекс сортировки', value: 'sortOrder', align: 'center' },
          {
            text: 'Основное меню',
            value: AggregatorsBrand.Setsushi,
            align: 'center',
            type: Boolean,
          },
          { text: 'Внешние источники', value: 'menuItemSources', align: 'start' },
          {
            text: 'Скрыто на сайте',
            value: 'hide',
            align: 'center',
            type: 'boolean-check',
          },
          {
            text: 'Скрыто в CRM',
            value: 'hideInCrm',
            align: 'center',
            type: 'boolean-check',
          },
          {
            text: 'Маркируемое',
            value: 'markable',
            align: 'center',
            type: 'boolean-check',
          },
          /*  {
            text: 'Допродажа сайт',
            value: 'upsale',
            align: 'center',
            type: 'boolean-check',
          },
          {
            text: 'Допродажа CRM',
            value: 'crmUpsale',
            align: 'center',
            type: 'boolean-check',
          }, */
        ],

        allowDelete: true,
        showStatusColumn: true,
      }
    },
    computed: {
      filter () {
        const filterData = {
          active: this.showOnlyActive ? 1 : 0,
        }

        if (this.selectedSource) {
          filterData.source = this.selectedSource
        }

        return filterData
      },
    },
    watch: {
      filter (value) {
        this.$router.push({
          path: this.$route.path,
          query: value,
        })
      },
      '$route.query.source': {
        handler: function (source) {
          console.log({ source })
          this.selectedSource = parseInt(source) || source
        },
        deep: true,
        immediate: true,
      },
      '$route.query.active': {
        handler: function (active) {
          console.log({ active })
          if (active === 0) {
            this.showOnlyActive = false
          } else {
            this.showOnlyActive = true
          }
        },
        deep: true,
        immediate: true,
      },
    },

    created () {
      /*  if (this.$route.query.source) {
        this.selectedSource = parseInt(this.$route.query.source) || this.$route.query.source
      } */
      /* if (this.$route.query.active === '0') {
        this.showOnlyActive = false
      } else {
        this.showOnlyActive = true
      } */
    },
    methods: {
      async downloadExcell () {
        this.loadingExcel = true
        const payload = {
          filialId: this.$store.getters['branches/getGlobalFilialId'],
        }

        try {
          await this.$store.dispatch('menuItems/downloadExcell', payload)
        } catch (err) {
          this.showErrorFromResponse(err)
        }

        this.loadingExcel = false
      },
    },
  }
</script>
<style lang="less" scoped>
.menu-brands-filter {
  padding: 0 15px;
}

.menu-items-list {
  ::v-deep {
    th {
      white-space: nowrap;
    }
  }

  &_sources {
    display: flex;

    &-item {
      display: inline-block;
      margin: 3px;
      font-size: 10px;
      line-height: 22px;
      height: 22px;
    }
  }

  &_active-filter {
    padding-right: 15px;
  }
}
</style>
